import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DiagnosisByKarteDetailFragment = { __typename?: 'DiagnosisByKarte', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, cards: { __typename?: 'Cards', annualIncome: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } }, user: { __typename?: 'DiagnosisUser', id: string, nickname: string, yearOfBirth: number, gender: Types.Gender, livingPrefecture: string, annualIncome: number, partnerAnnualIncome?: number | null, saving: number, investment: number, monthlyInsurance: number, hasPartner: boolean, hasChild: boolean, personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, children: Array<{ __typename?: 'Child', birthday: DateString, gender: Types.Gender }>, karte: { __typename?: 'DiagnosisKarte', id: string, plannerCommentCount: number, channel: Types.Channel, modifiedAt: TimeString, sameBranchPlannerCommented: boolean } } };

export type FetchKarteOnUseKarteUserDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchKarteOnUseKarteUserDetailQuery = { __typename?: 'Query', user: { __typename?: 'User', karte?: { __typename?: 'Karte', id: string, userComment: string, numberOfPlannerComments: number, hasCommentsFromPlannersBelongingToSameBranch: boolean, modifiedAt: TimeString, channel: Types.Channel, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', comment?: string | null } | null, topics: Array<{ __typename?: 'KarteTopic', id: string, name: string }>, diagnosis: { __typename?: 'Diagnosis', gender: Types.Gender, livingPrefecture: Types.Prefecture, birthYear: number, saving: number, annualIncome: number, savingMonth: number, monthlyRentCost: number, monthlyInsurance: number, investment: number, loanBalance?: number | null, children: Array<{ __typename?: 'DiagnosisChild', age: number, gender: Types.Gender }>, partner?: { __typename?: 'DiagnosisPartner', birthYear: number, annualIncome: number } | null, job?: { __typename?: 'Job', name: string } | null } } | null } };

export type DiagnosisByKarteQueryVariables = Types.Exact<{
  karteId: Types.Scalars['ID']['input'];
}>;


export type DiagnosisByKarteQuery = { __typename?: 'Query', diagnosisByKarte: { __typename?: 'DiagnosisByKarte', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, cards: { __typename?: 'Cards', annualIncome: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } }, user: { __typename?: 'DiagnosisUser', id: string, nickname: string, yearOfBirth: number, gender: Types.Gender, livingPrefecture: string, annualIncome: number, partnerAnnualIncome?: number | null, saving: number, investment: number, monthlyInsurance: number, hasPartner: boolean, hasChild: boolean, personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, children: Array<{ __typename?: 'Child', birthday: DateString, gender: Types.Gender }>, karte: { __typename?: 'DiagnosisKarte', id: string, plannerCommentCount: number, channel: Types.Channel, modifiedAt: TimeString, sameBranchPlannerCommented: boolean } } } };

export const DiagnosisByKarteDetailFragmentDoc = gql`
    fragment diagnosisByKarteDetail on DiagnosisByKarte {
  personality {
    type
    title
    description
  }
  cards {
    annualIncome {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    savingAnnual {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyRentCost {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    investment {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyInsurance {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
  }
  user {
    id
    nickname
    personality {
      type
      title
      description
    }
    yearOfBirth
    gender
    livingPrefecture
    annualIncome
    partnerAnnualIncome
    saving
    investment
    monthlyInsurance
    hasPartner
    hasChild
    children {
      birthday
      gender
    }
    karte {
      id
      plannerCommentCount
      channel
      modifiedAt
      sameBranchPlannerCommented
    }
  }
}
    `;
export const FetchKarteOnUseKarteUserDetailDocument = gql`
    query FetchKarteOnUseKarteUserDetail($id: ID!) {
  user(id: $id) {
    karte {
      id
      userComment
      ownKartePlannerComment {
        comment
      }
      numberOfPlannerComments
      topics {
        id
        name
      }
      hasCommentsFromPlannersBelongingToSameBranch
      modifiedAt
      channel
      diagnosis {
        gender
        livingPrefecture
        birthYear
        saving
        annualIncome
        savingMonth
        monthlyRentCost
        children {
          age
          gender
        }
        partner {
          birthYear
          annualIncome
        }
        monthlyInsurance
        investment
        job {
          name
        }
        loanBalance
      }
    }
  }
}
    `;

/**
 * __useFetchKarteOnUseKarteUserDetailQuery__
 *
 * To run a query within a Vue component, call `useFetchKarteOnUseKarteUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKarteOnUseKarteUserDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKarteOnUseKarteUserDetailQuery({
 *   id: // value for 'id'
 * });
 */
export function useFetchKarteOnUseKarteUserDetailQuery(variables: FetchKarteOnUseKarteUserDetailQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteUserDetailQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteUserDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>(FetchKarteOnUseKarteUserDetailDocument, variables, options);
}
export function useFetchKarteOnUseKarteUserDetailLazyQuery(variables?: FetchKarteOnUseKarteUserDetailQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteUserDetailQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteUserDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>(FetchKarteOnUseKarteUserDetailDocument, variables, options);
}
export type FetchKarteOnUseKarteUserDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKarteOnUseKarteUserDetailQuery, FetchKarteOnUseKarteUserDetailQueryVariables>;
export const DiagnosisByKarteDocument = gql`
    query diagnosisByKarte($karteId: ID!) {
  diagnosisByKarte(karteId: $karteId) {
    ...diagnosisByKarteDetail
  }
}
    ${DiagnosisByKarteDetailFragmentDoc}`;

/**
 * __useDiagnosisByKarteQuery__
 *
 * To run a query within a Vue component, call `useDiagnosisByKarteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosisByKarteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiagnosisByKarteQuery({
 *   karteId: // value for 'karteId'
 * });
 */
export function useDiagnosisByKarteQuery(variables: DiagnosisByKarteQueryVariables | VueCompositionApi.Ref<DiagnosisByKarteQueryVariables> | ReactiveFunction<DiagnosisByKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>(DiagnosisByKarteDocument, variables, options);
}
export function useDiagnosisByKarteLazyQuery(variables?: DiagnosisByKarteQueryVariables | VueCompositionApi.Ref<DiagnosisByKarteQueryVariables> | ReactiveFunction<DiagnosisByKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>(DiagnosisByKarteDocument, variables, options);
}
export type DiagnosisByKarteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DiagnosisByKarteQuery, DiagnosisByKarteQueryVariables>;